import { Card, Col, Row, Form } from "react-bootstrap";
import { ILicenseeReturnDetails } from "../../../api/ILicenseeReturns";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { LicenseeReturnIcon } from "../../../leap-components/icons/LeapIcons";

interface LicenseeReturnHeaderProps {
  licenseeReturn: ILicenseeReturnDetails;
}

const LicenseeReturnHeader = ({
  licenseeReturn,
}: LicenseeReturnHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <LicenseeReturnIcon />
                  </td>
                  <td>
                    <h2>Licensee Return: {licenseeReturn.reference}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={licenseeReturn.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={licenseeReturn.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={licenseeReturn.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LicenseeReturnHeader;
